export default {
    cta: "Vraag een<br/> Adviseur",
    ordered: "Besteld op {date}"
}